import React from 'react';
import { Link } from 'react-router-dom';

const CookiesPolicy = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-4">Cookies Information</h1>
      <p className="mb-4">
        Cookies are small text files that are placed on your computer or device by websites you visit. They are widely used to make websites work more efficiently and to provide information to website owners. Cookies serve various purposes, including remembering your preferences and settings, analyzing website traffic, and personalizing your browsing experience.
      </p>
      <p className="mb-4">
        There are different types of cookies, such as session cookies and persistent cookies. Session cookies are temporary and are erased when you close your web browser, while persistent cookies remain on your device for a set period or until you delete them manually. Cookies may also be classified as first-party cookies, which are set by the website you are visiting, or third-party cookies, which are set by other domains.
      </p>
      <p className="mb-4">
        Websites may use cookies for various purposes, such as authentication, security, advertising, and analytics. For example, cookies may be used to remember your login credentials, track your browsing behavior for targeted advertising, or analyze website traffic to improve user experience.
      </p>
      <p className="mb-4">
        You can control cookies through your web browser settings, where you can manage cookie preferences, block or delete cookies, and opt-out of certain types of tracking. However, please note that blocking or disabling cookies may affect the functionality of some websites and your browsing experience.
      </p>
      <p className="mb-4">
        By continuing to visit this site, you agree to our use of cookies as described in our <Link to="/PrivacyPolicy" className="underline transition-colors duration-200 hover:text-[#F25668]">privacy policy</Link>. If you have any concerns or questions about our use of cookies, please feel free to contact us.
      </p>

      <div className="mt-8">
        <Link to="/" className="bg-pink-600 hover:bg-pink-700 text-white font-bold py-1 px-2 rounded">
          Back
        </Link>
      </div>
    </div>
  );
};


export default CookiesPolicy;